import { useCartContext } from "app/providers/CartProvider";

import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { getFormattedPrice } from "../../../shared/utils/getFormattedPrice";
import { CreateCartPayload } from "shared/api/middleware-api-client";

const SampleSaleDoorPriceTable = ({
  cart,
  className,
}: {
  cart: CreateCartPayload;
  className?: string;
}) => {
  const { getFormattedSubTotalPrice, getCart } = useCartContext();

  if (!cart.discountRecords?.[0]) return <></>;
  const sampleSaleDiscount =
    cart.totalPrice - (cart.totalPrice * cart.discountRecords[0].value) / 100;
  return (
    <div
      className={concatClassnames(
        "gg-grid gg-grid-cols-12 gg-gap-x-4 gg-gap-y-3",
        className,
      )}
    >
      <div className="gg-col-span-9 gg-grid gg-gap-y-2.5 sm:gg-col-span-6">
        <Text>Subtotaal</Text>
      </div>
      <div className="gg-col-span-3 gg-grid gg-gap-y-2.5 gg-justify-self-end gg-text-right sm:gg-col-span-6 sm:gg-col-start-7 lg:gg-pl-0 lg:gg-text-left">
        <Text data-testid="subtotal-price" bold>
          {getFormattedSubTotalPrice()}
        </Text>
      </div>
      <div className="gg-col-span-9 gg-grid gg-gap-y-2.5 sm:gg-col-span-6">
        <Text>Sample sale</Text>
      </div>
      <div className="gg-col-span-3 gg-grid gg-gap-y-2.5 gg-justify-self-end gg-text-right sm:gg-col-span-6 sm:gg-col-start-7 lg:gg-pl-0 lg:gg-text-left">
        <Text
          className="gg-font-semibold gg-text-green-300"
          data-testid=" sample-sale-price"
        >
          -{getFormattedPrice(sampleSaleDiscount)}
        </Text>
      </div>
    </div>
  );
};
export default SampleSaleDoorPriceTable;
